import { Navigate } from "react-router-dom";
import { useUserRole } from "@/hooks/useUserRole";

interface AdminRouteProps {
  children: React.ReactNode;
  requireOrderAccess?: boolean;
  requireProductAccess?: boolean;
  requireContentAccess?: boolean;
}

const AdminRoute = ({ children, requireOrderAccess = false, requireProductAccess = false, requireContentAccess = false }: AdminRouteProps) => {
  const { isAdmin, role, isLoading } = useUserRole();
  
  // Allow admins, moderators, order_managers, and content_managers
  const hasAccess = isAdmin || role === 'moderator' || role === 'order_manager' || role === 'content_manager';
  
  // Check specific access requirements
  const hasOrderAccess = isAdmin || role === 'moderator' || role === 'order_manager';
  const hasProductAccess = isAdmin || role === 'moderator';
  const hasContentAccess = isAdmin || role === 'moderator' || role === 'content_manager';
  
  console.log("AdminRoute: Checking access", { 
    isAdmin, 
    role, 
    hasAccess, 
    hasOrderAccess,
    hasProductAccess,
    hasContentAccess,
    requireOrderAccess, 
    requireProductAccess, 
    requireContentAccess, 
    isLoading 
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // If specific access is required, check it
  if (requireOrderAccess && !hasOrderAccess) {
    console.log("AdminRoute: Access denied - no order access");
    return <Navigate to="/" replace />;
  }

  if (requireProductAccess && !hasProductAccess) {
    console.log("AdminRoute: Access denied - no product access");
    return <Navigate to="/" replace />;
  }

  if (requireContentAccess && !hasContentAccess) {
    console.log("AdminRoute: Access denied - no content access");
    return <Navigate to="/" replace />;
  }

  if (!hasAccess) {
    console.log("AdminRoute: Access denied - not an admin or moderator");
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
